<template>
  <div class="my-10">
    <div class="flex justify-between items-center mb-5">
      <h1 class="text-3xl text-main-color font-semibold">{{ $t('nav.brands') }}</h1>

      <div class="relative">
        <input
          type="text"
          v-model="searchText"
          class="block w-80 py-2 px-6 text-sm .placeholder-accent-gray-color::placeholder text-main-color border border-[#e6e6e6] rounded-lg bg-white"
          :placeholder="$t('page.searchBrandByName')"
          required
        />
        <div class="absolute z-10 inset-y-0 end-0 p-5 cursor-pointer flex items-center">
          <IconSearch></IconSearch>
        </div>
      </div>
    </div>
    <div class="grid gap-5 grid-cols-4 max-lg:grid-cols-3 max-md:grid-cols-2">
      <router-link
        v-for="(brand, index) in filteredBrands"
        :key="index"
        :to="{ name: 'brandProducts', params: { id: brand.id }, query: { brandName: brand.name } }"
      >
        <BrandCard :detail="brand" />
      </router-link>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import IconSearch from '@icons/IconSearch.vue';
import BrandCard from '@cmp/mall/BrandCard.vue';
export default {
  name: 'brands',
  components: {
    BrandCard,
    IconSearch,
  },
  data() {
    return {
      loading: false,
      brands: [],
      searchText: undefined,
    };
  },
  methods: {
    async getBrands() {
      this.loading = true;
      try {
        const response = await api.get('mall/brands/', {
          params: {
            location: this.getLocationId,
          },
        });
        this.brands = response.data;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
  computed: {
    filteredBrands() {
      if (!this.searchText) {
        return this.brands;
      }
      const lowerCaseSearchText = this.searchText.toLowerCase();
      return this.brands.filter(el => el.name.toLowerCase().includes(lowerCaseSearchText));
    },
    getLocationId() {
      const location = JSON.parse(localStorage.getItem('selectedLocation')) || 1;
      return typeof location === 'object' ? location?.id : location;
    },
  },
  async created() {
    await this.getBrands();
  },
};
</script>
